import { Box, Button, Grid, Modal, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { updateAttributeApi } from "src/api/commonapi";
import { notification } from "src/utils/messages";

export default function LeadStatusInsertUpdateModal({
  addEditModal,
  setAddEditModal,
  toggleAddEditModal,
  modalType,
  rowData,
  handleGetAttributeList
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [leadStatusData, setLeadStatusData] = useState({
    name: modalType === "Edit" ? rowData?.name : "",
    description: modalType === "Edit" ? rowData?.description : ""
  });
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    if (leadStatusData.name != "" && modalType === "Edit") {
      setLoader(true);
      let resp = await updateAttributeApi({ ...leadStatusData, a_id: rowData.a_id });
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status != 0) {
        setLeadStatusData({
          name: "",
          description: ""
        });
        toggleAddEditModal();
        handleGetAttributeList();
      }
      setLoader(false);
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };
  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} Lead Status
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginTop: "20px" }}
                fullWidth
                required
                autoComplete="off"
                type="text"
                label="Lead Status Name"
                size="small"
                name="name"
                placeholder="Enter Lead Status Name"
                onChange={(e) => {
                  setLeadStatusData({
                    ...leadStatusData,
                    name: e.target.value
                  });
                }}
                value={leadStatusData?.name}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                style={{ marginTop: "20px" }}
                fullWidth
                required
                autoComplete="off"
                type="text"
                label="Lead Status Description"
                size="small"
                multiline
                rows={3}
                name="description"
                placeholder="Enter Lead Status Description"
                onChange={(e) => {
                  setLeadStatusData({
                    ...leadStatusData,
                    description: e.target.value
                  });
                }}
                value={leadStatusData?.description}
              />
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAddEditModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleSubmit()}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
